import { getJson } from 'utils/http/getJson';
import { postJson } from 'utils/http/postJson';

import { ApiNotification } from './types/ApiNotification';

export async function apiFetchNotifications(): Promise<Array<ApiNotification>> {
  return getJson<{ notifications: ApiNotification[] }>(
    '/data/notifications',
  ).then(({ notifications }) => notifications);
}

export async function apiMarkNotificationsAsViewed(
  notificationIds: Array<string>,
) {
  return postJson<{
    notifications: ApiNotification[];
  }>('/data/notifications-viewed', {
    notificationIds,
  }).then(({ notifications }) => notifications);
}

export async function apiMarkNotificationsAsRead(
  notificationIds: Array<string>,
): Promise<Array<ApiNotification>> {
  return postJson<{
    notifications: ApiNotification[];
  }>('/data/notifications-read', {
    notificationIds,
  }).then(({ notifications }) => notifications);
}

export async function apiMarkNotificationsAsDismissed(
  notificationIds: Array<string>,
): Promise<Array<ApiNotification>> {
  return postJson<{
    notifications: ApiNotification[];
  }>('/data/notifications-dismissed', {
    notificationIds,
  }).then(({ notifications }) => notifications);
}
